import { render, staticRenderFns } from "./configRule.vue?vue&type=template&id=36bebda0&scoped=true"
import script from "./configRule.vue?vue&type=script&lang=js"
export * from "./configRule.vue?vue&type=script&lang=js"
import style0 from "./configRule.vue?vue&type=style&index=0&id=36bebda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bebda0",
  null
  
)

export default component.exports